import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  Input,
  Text,
} from '@chakra-ui/react';
import type { Dispatch } from 'react';

import type { TabContentAction } from '../PageConfigProvider/page-reducer';
import type { PositionedItem } from '../PageConfigProvider/types/item';
import { ArrowDirectionSelector } from './ArrowDirectionSelector';
import labelStyles from './section-label.module.css';

type DivergingBarSettingsProps = {
  item: PositionedItem;
  dispatch: Dispatch<TabContentAction>;
};

export const DivergingBarSettings = ({
  item,
  dispatch,
}: DivergingBarSettingsProps) => {
  const id = item?.id;

  return (
    <AccordionItem borderTop="none">
      <h2>
        <AccordionButton width="100%" paddingLeft={2} paddingRight=".625rem">
          <Text
            className={labelStyles.sectionLabel}
            as="span"
            flex="1"
            textAlign="left"
            fontSize="sm"
            fontWeight="600"
          >
            Arrows & labels
          </Text>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel>
        <Flex direction="column" gap={3}>
          <Box>
            <Text fontSize="sm" fontWeight="500" mb={2}>
              Arrow orientation
            </Text>
            <ArrowDirectionSelector item={item} />
          </Box>
          <Box>
            <Text fontSize="sm" fontWeight="500" mb={1}>
              Positive Label
            </Text>
            <Input
              size="sm"
              placeholder=""
              value={item.plot?.divergingBar?.positiveLabel ?? ''}
              onChange={(e) => {
                dispatch({
                  type: 'UPDATE_ITEM_DIVERGING_BAR',
                  payload: {
                    id,
                    divergingBar: {
                      ...item.plot?.divergingBar,
                      positiveLabel: e.target.value,
                    },
                  },
                });
              }}
            />
          </Box>
          <Box>
            <Text fontSize="sm" fontWeight="500" mb={1}>
              Negative Label
            </Text>
            <Input
              size="sm"
              placeholder=""
              value={item.plot?.divergingBar?.negativeLabel ?? ''}
              onChange={(e) => {
                dispatch({
                  type: 'UPDATE_ITEM_DIVERGING_BAR',
                  payload: {
                    id,
                    divergingBar: {
                      ...item.plot?.divergingBar,
                      negativeLabel: e.target.value,
                    },
                  },
                });
              }}
            />
          </Box>
        </Flex>
      </AccordionPanel>
    </AccordionItem>
  );
};
